<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
    <td class="pa-3 pl-4 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-checkbox
              class="ma-0"
              dense
              hide-details="true"
              v-model="selectAllDataNew"
            ></v-checkbox>
          </div>
        </template>
        <span>Select All</span>
      </v-tooltip>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.reference_number"
        type="text"
        label="Nomor Pengajuan"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearAndGetData('reference_number')"
      ></v-text-field>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.mid"
        type="text"
        label="MID"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearAndGetData('mid')"
      ></v-text-field>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
  </tr>
</template>

<script>

export default {
  props: ['search', 'dataList', 'selectAllData', 'selectedData'],
  data: () => ({}),
  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    selectAllDataNew: {
      get() {
        return this.selectAllData;
      },
      set(val) {
        this.selectAll(val);
        this.$emit('selectAllDataParent', val);
      },
    },
  },

  methods: {
    clearAndGetData(field) {
      this.searchData[field] = ''; 
      this.getData(); 
    },
    getData() {
      this.$emit('getDataParent');
    },

    selectAll(status) {
      this.$nextTick(() => {
        const allIds = this.dataList.map((val) => val.id);

        const filtered = allIds.filter(
          (val) => !this.selectedData.includes(val)
        );

        if (status) {
          this.$emit('selectedDataParent', this.selectedData.concat(filtered));
        } else {
          const newSelected = this.selectedData.filter(
            (val) => !allIds.includes(val)
          );
          this.$emit('selectedDataParent', newSelected);
        }
      });
    },
  },
};
</script>
